exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 1100px){.app-invitation-card-legacy-card-1Se163Dcmwr{display:none}}.app-invitation-card-app-invitation-card-Bsj7mqAdmwr{display:none;margin-top:24px}@media (max-width: 1100px){.app-invitation-card-app-invitation-card-Bsj7mqAdmwr{display:block}}.app-invitation-card-app-icon-A6Z1X4nomwr{margin-top:calc(-24px + -20px)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"legacy-card": "app-invitation-card-legacy-card-1Se163Dcmwr",
	"legacyCard": "app-invitation-card-legacy-card-1Se163Dcmwr",
	"app-invitation-card": "app-invitation-card-app-invitation-card-Bsj7mqAdmwr",
	"appInvitationCard": "app-invitation-card-app-invitation-card-Bsj7mqAdmwr",
	"app-icon": "app-invitation-card-app-icon-A6Z1X4nomwr",
	"appIcon": "app-invitation-card-app-icon-A6Z1X4nomwr"
};